import { createContext, useContext, useCallback, type ReactNode } from 'react';

interface NotificationPanelContextValue {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  toggle: () => void;
}

const NotificationPanelContext =
  createContext<NotificationPanelContextValue | null>(null);

export function NotificationPanelProvider({
  children,
  isOpen,
  onOpenChange,
}: {
  children: ReactNode;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const toggle = useCallback(
    () => onOpenChange(!isOpen),
    [isOpen, onOpenChange]
  );
  const value: NotificationPanelContextValue = {
    isOpen,
    onOpenChange,
    toggle,
  };
  return (
    <NotificationPanelContext.Provider value={value}>
      {children}
    </NotificationPanelContext.Provider>
  );
}

export function useNotificationPanel(): NotificationPanelContextValue {
  const ctx = useContext(NotificationPanelContext);
  if (!ctx) {
    throw new Error(
      'useNotificationPanel must be used within NotificationPanelProvider'
    );
  }
  return ctx;
}
